module.exports = __webpack_public_path__ + "assets/d7aa1821718eb36e80d3f0f53900adfd.png";